<template>
	<div class="space-y-4">
		<ui-validation-message
			:form="form"
			field="extra.contract"
			v-if="form.hasErrors"
		/>
		<div>
			<p class="font-medium text-gray-700" v-if="!noLabel">
				{{ __("Contract Conditions") }}
				<span class="text-gray-500 font-normal ml-3" v-if="!isExtraRequired"
					>optional</span
				>
			</p>
			<div class="mt-1 flex flex-col sm:flex-row gap-x-6 gap-y-2">
				<ui-radio-group
					v-model="form.extra.contract"
					radioValue="EHB"
					:key="'EHB-' + form.extra.contract"
					:form="form"
					field="extra.contract"
					name="extra.contract"
					label="Standard conditions"
				></ui-radio-group>

				<ui-radio-group
					v-model="form.extra.contract"
					radioValue="EHB_CUSTOM"
					:key="'EHB_CUSTOM-' + form.extra.contract"
					:form="form"
					field="extra.contract"
					name="extra.contract"
					label="Standard conditions based on buy-out conditions"
				/>
			</div>

			<ui-validation-message :form="form" field="form.extra" />
		</div>

		<div
			class="mt-6 flex flex-col sm:grid sm:grid-cols-2 gap-y-4 sm:gap-x-6 sm:items-end"
		>
			<ui-select-group
				v-model="form.extra.payment_terms"
				class="w-full"
				field="extra.payment_terms"
				type="select"
				label="Payment Conditions"
				:options="$cropOptions.paymentTermsOptions"
				:form="form"
				:required="isExtraRequired"
			></ui-select-group>

			<ui-select-group
				class="w-full"
				v-model="form.extra.payment_mode"
				field="extra.payment_mode"
				type="select"
				label="Payment Method"
				:options="$cropOptions.paymentModeOptions"
				:form="form"
				:required="isExtraRequired"
			></ui-select-group>

			<ui-check-group
				class="col-span-2 flex"
				v-model="form.extra.average_across_deliveries"
				field="extra.average_across_deliveries"
				label="Billing in the average of the total lot"
				:form="form"
			></ui-check-group>
		</div>

		<ui-check-group
			v-model="form.variety_protection_enabled"
			field="variety_protection_enabled"
			label="EU Plant Variety Protection"
			:tooltip-text="euVarietyProtectionInfo"
			:form="form"
			:disabled="
				(user && user.type == 'FARMER') ||
				(reference &&
					reference.user &&
					reference.user.type == 'FARMER' &&
					reference.trade == 'SELL' &&
					reference.variety_protection_enabled) ||
				(reference &&
					reference.reference_tradable &&
					counterpart &&
					counterpart.type == 'FARMER' &&
					reference.reference_tradable.trade == 'BUY' &&
					reference.variety_protection_enabled)
			"
		></ui-check-group>

		<ui-textarea-group
			v-model="form.extra.text"
			field="extra.text"
			label="Additional terms relevant to the contract"
			tooltip-text="Additions to contract-relevant characteristics with regard to quality, deadline, loading or other. Will be printed on the contract."
			:form="form"
			:required="false"
		></ui-textarea-group>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		isExtraRequired: {
			type: Boolean,
			default: true,
		},
		noLabel: {
			type: Boolean,
			default: false,
		},
		user: {
			type: Object,
			required: false,
		},
		reference: {
			type: Object,
			required: false,
		},
		counterpart: {
			type: Object,
			required: false,
		},
	},
	computed: {
		euVarietyProtectionInfo: function () {
			return this.__("eu_variety_protection_info");
		},
	},
};
</script>
